import { Api } from "./Api";
import { AvisDeVirementLigne } from "../models/AvisDeVirementLigne";

export class AvisDeVirementLigneApi extends Api {
    constructor() {
        super("document/avis-de-virement-ligne");
    }

    save(
        ligne: AvisDeVirementLigne,
        params?: Object
    ): Promise<AvisDeVirementLigne> {
        return super
            .saveResource(ligne.serialize(), params)
            .then(function (response) {
                return new AvisDeVirementLigne(response.data.data);
            });
    }
}
